import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {
  MediaComponent,
  MediaCreateComponent,
  MediaUpdateComponent,
  MediaListComponent,
  MediaStatisticComponent
} from 'src/app/business/media';

const routes: Routes = [
  {
    path: '',
    component: MediaComponent,
    children: [
      {
        path: '',
        component: MediaListComponent
      },
      {
        path: 'statistic',
        component: MediaStatisticComponent
      },
    ]
  },
  {
    path: 'create',
    component: MediaCreateComponent
  },
  {
    path: 'update/:id',
    component: MediaUpdateComponent,
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MediaRoutingModule { }
